import { Field } from "formik";
import FieldRequired from "./FieldRequired";






const PaymentDescriptionInput = ({errors, touched, values}) => {

    return (
      <div className="flex-item width-12">
        <div className="FormFieldGroup" data-qa="FormFieldGroup-email">
          <div className="FormFieldGroup-labelContainer flex-container justify-content-space-between">
            <label htmlFor="email">
              <span className="Text Text-color--gray600 Text-fontSize--15 Text-fontWeight--500">
                Ödeme Açıklaması
              </span>
            </label>
            {errors.orderDesc && touched.orderDesc ? <FieldRequired /> : null}
          </div>
          <div className="FormFieldGroup-Fieldset" id="email-fieldset">
            <div className="FormFieldGroup-container">
              <div className="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop FormFieldGroup-childBottom">
                <div className="FormFieldInput">
                  <div className="CheckoutInputContainer">
                    <span className="InputContainer" >
                      <Field className={`CheckoutInput Input Input--empty ${errors.orderDesc && touched.orderDesc ? "CheckoutInput--invalid" : ""}`}
                        id="orderDesc"
                        name="orderDesc"
                        type="text"
                        inputMode="text"
                        value={values.orderDesc}
                        maxlength={100}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  export default PaymentDescriptionInput;